import "../lib/setimmediate-polyfill.js";
import React from "react";
import ReactDOM from "react-dom/client";
import r2wc from "react-to-webcomponent";
import WebSerialWarning from "../components/WebSerialWarning";
import Wizard from "../components/Wizard";
import { useBaseWizardContext } from "../hooks/useBaseWizardContext";
import styles from "../index.css?inline";
import { configureWizardConfig } from "../wizards/configure";

const standaloneConfig = { ...configureWizardConfig, standalone: true };

function ConfigureWizard() {
	const baseContext = useBaseWizardContext();

	if (!("serial" in navigator)) {
		return (
			<>
				<style>{styles}</style>
				<div className="bg-app-primary min-h-screen">
					<WebSerialWarning />
				</div>
			</>
		);
	}

	return (
		<>
			<style>{styles}</style>
			<Wizard config={standaloneConfig} baseContext={baseContext} />
		</>
	);
}

// Convert the React component to a web component
const ConfigureWebComponent = r2wc(ConfigureWizard, React, ReactDOM);

// Register the web component
customElements.define("configure-zwa2", ConfigureWebComponent);

export default ConfigureWizard;
